<template>
  <div :class="flexWrapClasses">
    <div class="inner">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FlexWrap',
  props: {
    above: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    flexWrapClasses () {
      return {
        'flex-wrap': true,
        'above': this.above
      }
    }
  }
}
</script>

<style scoped lang="scss">
.flex-wrap {
  padding-top: 100px;
  padding-bottom: 100px;
}

.above {
  margin-top: -100px;
}

@media (min-width: 768px) {
  .flex-wrap {
    min-height: 100vh;
    padding-top: 150px;
    padding-bottom: 150px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .above {
    margin-top: -25vh;
  }
}
</style>
